/**
 * Medical Records Sorting Constants
 *
 * These constants define the sorting column IDs and order-by values
 * used in the medical records table for API requests.
 */

/** Column ID for the "Added By" (uploadedBy) sorting column */
export const SORTING_COLUMN_UPLOADED_BY = 'uploadedBy';

/** Column ID for the "GDPR Check by" (checkedBy) sorting column */
export const SORTING_COLUMN_CHECKED_BY = 'checkedBy';

/** Order-by value for default sorting */
export const ORDER_BY_DEFAULT = 'DEFAULT';

/** Order-by value for sorting by upload date */
export const ORDER_BY_DATE = 'DATE';

/** Order-by value for sorting by GDPR check date */
export const ORDER_BY_CHECK_DATE = 'CHECK_DATE';

/**
 * Document Processing Status Constants
 *
 * These arrays define the document processing statuses that are considered
 * "in progress" or "error" states, used for rendering spinners and error icons
 * in the medical records table.
 */

/** Document statuses that indicate processing is in progress */
export const DOCUMENT_PROCESSING_STATUSES = [
  'Uploading',
  'Validating',
  'Applying OCR',
  'Preprocessing',
  'Removing Breach Pages',
] as const;

/** Document statuses that indicate an error or failure */
export const DOCUMENT_ERROR_STATUSES = [
  'Upload Failed',
  'Validation Error',
  'OCR Failed',
  'Preprocessing Failed',
  'Unknown Pipeline Error',
] as const;
